"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_FLIGHT_CHANGE = void 0;
exports.CREATE_FLIGHT_CHANGE = {
    USER_NOT_FOUND: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
        },
    },
    CLIENT_NOT_FOUND: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'CLIENT_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Cliente não encontrado.',
        },
    },
    TRAVEL_NOT_FOUND: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'TRAVEL_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Viagem não encontrado.',
        },
    },
    OFFER_NOT_FOUND: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'OFFER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'A oferta original não encontrada.',
        },
    },
    USER_NOT_BELONG_TO_CLIENT: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'USER_NOT_BELONG_TO_CLIENT',
        messageLangMap: {
            'PT-BR': 'O usuário logado não é válido.',
        },
    },
    CABIN_CLASS_NOT_ALLOWED: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'CABIN_CLASS_NOT_ALLOWED',
        messageLangMap: {
            'PT-BR': 'Opção de cabine não permitida.',
        },
    },
    OFFER_IS_NOT_FLIGHT: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'OFFER_IS_NOT_FLIGHT',
        messageLangMap: {
            'PT-BR': 'A oferta não é do tipo aéreo.',
        },
    },
    SUPPLIER_UNSUPPORTED_CHANGE: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'SUPPLIER_UNSUPPORTED_CHANGE',
        messageLangMap: {
            'PT-BR': 'O fornecedor não suporta alterações nas ofertas.',
        },
    },
    SUPPLIER_CONFIG_NOT_FOUND: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'SUPPLIER_CONFIG_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Configuração do fornecedor não encontrada.',
        },
    },
    EXIST_OPEN_REQUESTS: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'EXIST_OPEN_REQUESTS',
        messageLangMap: {
            'PT-BR': 'Apenas uma solicitação é permitida por oferta.',
        },
    },
    OFFER_IS_NOT_EMITTED: {
        usecase: 'CREATE_FLIGHT_CHANGE',
        type: 'OFFER_IS_NOT_EMITTED',
        messageLangMap: {
            'PT-BR': 'Não é possível solicitar modificações em ofertas não emitidas.',
        },
    },
};
